/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";

import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";


import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";


import {NavLink} from "react-router-dom";

import {Col} from "react-bootstrap";


import BlockContentContainerComponent from "@Components/UI/Containers/Block";


import LOGO from "@Images/logo.png";


type ApplicationHeaderComponentProps = {
    cssClasses?: string;
};


export const ApplicationHeaderComponent: React.FC<ApplicationHeaderComponentProps> = ({
    cssClasses = ""
}): JSX.Element | null => {


    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state):ReturnType<any> => state?.authentication
    )?.loggedUser || null;


    return (
        <BlockContentContainerComponent as={"header"} cssClasses={"application-header-component" + (cssClasses ? ` ${cssClasses}` : "")}>

            <Col xs={10} className={"header-avatar-component"}>
                <NavLink to={"/ustawienia"} title={"Profil"}>
                    <img src={LOGO} alt={``} />
                </NavLink>
            </Col>

            {!!LOGGED_USER &&
	        <Col xs={12} className={"header-user-component"}>
		        <span className={"user-label"}>{`Witaj`}</span>
		        <span className={"user-name"}>{LOGGED_USER?.userFirstName} {LOGGED_USER?.userLastName}</span>
	        </Col>
            }

        </BlockContentContainerComponent>
    );

};


export default ApplicationHeaderComponent;
